export * from './FavoriteButton';

import { FavoriteButton } from './FavoriteButton';
export default FavoriteButton;
